import { jsx, jsxs } from 'react/jsx-runtime';
import { Text } from '@dls/web';
import { useCallback, useEffect } from 'react';
import { SCPopupAccountSettings, SCWrapperAccContent, SCWrapperHeader, SCCloseIcon, SCWrapperBody } from './styles.js';
import theme from '../../../../../theme/index.js';
import '../../../../../../../authentication/context/AuthenticationProvider.js';
import '@geit/ui-components';
import { useNavigate } from '../../../../../../../authentication/hooks/useNavigate.js';
import 'qs';
import 'uuid';
import '../../../../../../../authentication/navigate.js';
const accountSettingsMenu = [{
  featureName: "My profile",
  url: "/account/profile"
}, {
  featureName: "My access rights",
  url: "/account/access-rights"
}, {
  featureName: "Notification settings",
  url: "/account/notifications"
}];
const AccountSettings = _ref => {
  let {
    open,
    onClose
  } = _ref;
  const navigate = useNavigate();
  const ts = useCallback(e => {
    const mDiv = document.getElementById("header-profile-account-setting");
    if (mDiv) {
      if (!mDiv.contains(e.target)) {
        onClose();
      }
    }
  }, [onClose]);
  useEffect(() => {
    if (open) {
      window.addEventListener("click", ts);
    } else {
      window.removeEventListener("click", ts);
    }
  }, [open, ts]);
  const gotoLinkFeature = url => {
    navigate(url);
    onClose();
  };
  return /* @__PURE__ */jsx(SCPopupAccountSettings, {
    open,
    id: "header-profile-account-setting",
    children: /* @__PURE__ */jsx("div", {
      children: /* @__PURE__ */jsxs(SCWrapperAccContent, {
        children: [/* @__PURE__ */jsx(SCWrapperHeader, {
          onClick: onClose,
          children: /* @__PURE__ */jsx(SCCloseIcon, {})
        }), /* @__PURE__ */jsx(Text, {
          type: "boldBody",
          children: "Account settings"
        }), /* @__PURE__ */jsx(SCWrapperBody, {
          children: accountSettingsMenu.map((acc, idex) => /* @__PURE__ */jsx("div", {
            onClick: () => gotoLinkFeature(acc.url),
            children: /* @__PURE__ */jsx(Text, {
              type: "smallBody",
              color: location.pathname === acc.url ? theme.colours.singtelred : "",
              children: acc.featureName
            })
          }, idex))
        })]
      })
    })
  });
};
export { AccountSettings as default };